<template>
  <v-card class="rounded-lg pa-2 white" flat>
    <v-card-title class="secondary--text"> {{title}}
      <v-spacer></v-spacer>
      <chart-export-btn :page-chart-id="chart_id"></chart-export-btn>

    </v-card-title>
    <v-card-subtitle class="primary--text">ده کالای برتر</v-card-subtitle>
    <canvas  height="100" :id="chart_id"></canvas>
  </v-card>
</template>

<script>
import Chart from 'chart.js'
import ChartExportBtn from "@/components/scomponents/ChartExportBtns";
export default {
  name: 'TopGoodChart',
  components: {ChartExportBtn},
  data() {
    return {
      chartData: {
        type: "bar",
        data: {
          labels: [],
          datasets: [
            {
              label: "",
              data: [],
              backgroundColor: "#FF8700",
              borderColor: "#FF8700",
              borderWidth: 3,
              hoverBorderWidth:5
            },
          ]
        },
        options: {
          title: {
            display: true,
            text: '',
            fontColor: "#000",
            fontSize: 18,
          },

          responsive: true,
          tooltips: {
            enabled: true,
            mode: 'index',
            position: 'average',
            callbacks: {
              label: function (tooltipItem, data) {
                let label = data.datasets[tooltipItem.datasetIndex].label || ''
                if (label) {
                  label += ' : '
                }
                if(parseInt(tooltipItem.yLabel) >= 1000){
                  label += tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' ريال ';
                } else {
                  label += tooltipItem.yLabel + ' ريال ';
                }
                return label
              },
            },
          },

          scales: {
            xAxes: [{
              gridLines: {
                display: false,
              }
            }],
            yAxes: [
              {
                gridLines: {
                  color: "rgba(161, 161, 161, .08)",
                },
                ticks: {
                  beginAtZero: true,
                  padding: 15,
                  callback: function(value, index, values) {
                    if(parseInt(value) >= 1000){
                      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' ريال ';
                    } else {
                      return value + ' ريال ';
                    }
                  }

                }
              }
            ]
          }
        }
      },
    }
  },
  props: {
    report_type: {
      default: 'buy',
    },
  },
  methods : {
    setChartStyle(){
      if (this.report_type == 'sale') {
        this.setSaleChartColors()
      }
      this.chartData.data.datasets[0].label = `${this.type}  خالص`
    },

    setSaleChartColors(){
      this.chartData.data.datasets[0].backgroundColor = '#002357'
      this.chartData.data.datasets[0].borderColor = '#002357'
    },

    getChartFromApi(){
      this.request({
        url: this.endpoint(`reports/BuySaleSumByWare?type=${this.report_type}`),
        method: "get",
        success: data => {
          this.setData(data.results)
        }
      })
    },

    setData(data) {
      this.chartData.options.title.text = 'شرکت ' + this.company.name + '  سال مالی ' + this.financialYear.name
      this.chartData.options.title.fontSize =  13
      this.chartData.data.labels = []
      this.chartData.data.datasets[0].data = []

      for (let ware of data){
        this.chartData.data.labels.push(ware.title)
        this.chartData.data.datasets[0].data.push(ware.amount)

      }

      this.setChart()
    },
    setChart(){
      this.setChartStyle()
      const ctx = document.getElementById(`${this.chart_id}`);
      new Chart(ctx, this.chartData);
    }

  },

  mounted() {
    this.getChartFromApi()
  },
  computed: {
    chart_id() {
      if (this.report_type == 'buy') {
        return 'top-buy-ware-chart'
      } else {
        return 'top-sale-ware-chart'
      }
    },
    title() {
      if (this.report_type == 'buy') {
        return 'بیشترین خرید'
      } else {
        return 'پر فروش ترین ها'
      }
    },
    type() {
      if (this.report_type == 'buy') {
        return 'خرید'
      } else {
        return 'فروش'
      }
    },

  },

}
</script>